import { render, staticRenderFns } from "./ImpactChart.vue?vue&type=template&id=134240ff&scoped=true&"
import script from "./ImpactChart.vue?vue&type=script&lang=js&"
export * from "./ImpactChart.vue?vue&type=script&lang=js&"
import style0 from "./ImpactChart.vue?vue&type=style&index=0&id=134240ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134240ff",
  null
  
)

export default component.exports